module.exports = __webpack_public_path__ + "static/media/location-maps-letter-f-arrow-serr2.89adb139.png";